<!-- 资源查看 -->
<template>
    <div class="el-resourceView">
        <el-dialog
            :title="showResourceType ==3?'电子教材查看':'资源查看'"
            :visible.sync="showSMS"
            width="800px"
            @close="close"
            >
            <el-row>
                <el-table
                    border
                    :data="listInfo"
                    height="400"
                    style="width: 100%;">
                    <el-table-column prop="courseResourceName" :label="showResourceType ==3?'教材名称':'资源名称'">
                    </el-table-column>
                    <el-table-column prop="address" align="center" width="180" label="操作">
                        <template slot-scope="scope">
                            <el-button @click="downloadClick(scope.row)" v-if="showResourceType != 3" type="text" size="small">下载</el-button>
                            <template v-if="
                                $matchType(scope.row.courseResourceUrl) == 'image' ||
                                $matchType(scope.row.courseResourceUrl) == 'excel' ||
                                $matchType(scope.row.courseResourceUrl) == 'word' ||
                                $matchType(scope.row.courseResourceUrl) == 'pdf' ||
                                $matchType(scope.row.courseResourceUrl) == 'ppt' ||
                                $matchType(scope.row.courseResourceUrl) == 'video'
                            ">
                                <el-button type="text" @click="preview(scope.row)" size="small">预览</el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitInfo">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="资源预览"
            :visible.sync="showView"
            width="1000px"
            top="10vh"
            :fullscreen="isFullscreen"
            @close="viewClose"
            >
            <i class="el-icon-full-screen" v-if="isFullscreen !=true" style="position: absolute;top: 21px;right: 50px;cursor: pointer;" @click="isFullscreen = true" title="全屏"></i>
            <i class="el-icon-copy-document" v-else="isFullscreen" style="position: absolute;top: 21px;right: 50px;cursor: pointer;" @click="isFullscreen = false" title="还原"></i>
            <el-row>
                <!-- <el-row v-if="show.load" class="showBox tc" style="display: flex;justify-content:center;align-items:center;">
                  <i class="el-icon-loading font30"></i>
                </el-row> -->
                <el-row v-show="show.PDFShow" class="showBox" :style="(isFullscreen == true?'height:calc(100vh - 100px)':'')">
                  <lookPdf v-if="!$isEmpty(show.PDFUrl)" :pdfUrl="show.PDFUrl"></lookPdf>
                </el-row>
                <!-- 视频查看 -->
                <el-row v-show="show.mp4Show" class="showBox" :style="(isFullscreen == true?'height:calc(100vh - 100px)':'')">
                  <video @timeupdate="onTimeupdate" id="myVideo" style="width: 100%;height: 100%;" class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="allow" poster="" webkit-playsinline playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto">
                      <source type="application/x-mpegURL">
                  </video>
                </el-row>
                <el-row v-show="show.fileShow" class="showBox" :style="(isFullscreen == true?'height:calc(100vh - 100px)':'')">
                  <iframe id="InformationURL" :src='show.fileUrl' width='100%' height='100%' frameborder='1'></iframe>
                </el-row>
                <el-row v-show="show.imgShow" class="showBox" style="overflow: auto;padding: 20px;height: 500px;">
                  <!-- <h2 style="text-align: center;">{{show.imgTitle}}</h2> -->
                  <el-image
                      style="height:450px;display: block;text-align: center;"
                      :src="show.imgUrl"
                      :preview-src-list="[show.imgUrl]">
                    </el-image>
                </el-row>
            </el-row>
            <span slot="footer" class="dialog-footer">

            </span>
        </el-dialog>
    </div>
</template>

<script>
import {get, post} from '@/common/request';
import lookPdf from "@/components/lookPdf"; //引入PDF查看器
export default {
    name: "resourceView",
    components: {
    	lookPdf,
    },
    props: {
    	tePlanCourseId: { //教学计划ID
    	  type: String,
    	  default: ""
    	},
        showResource:{
            type:Boolean,
            default:false
        },
        showResourceType:{ //类型
            type: String,
            default: ""
        }
    },
    data() {
        return {
            showSMS:false,
            showView:false,
            isFullscreen:false,
            listInfo:[],
            studentInfo:sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag()),
            player:null,
            show:{
              load:true,
              PDFShow:false,
              PDFUrl:"",
              mp4Show:false,
              mp4Url:"",
              fileShow:false,
              fileUrl:"",
              imgShow:false,
              imgUrl:"",
              imgTitle:"",
              httpShow:false,
              httpUrl:"",
            },
        };
    },
    mounted() {
        this.showSMS = this.showResource;
        this.getStuNewVerifyPhoneOpenConfig();
        // this.initVideo();
    },
    methods: {
        getStuNewVerifyPhoneOpenConfig(){ //获取教学计划资源
            if(this.$isEmpty(this.tePlanCourseId)){
                return;
            }
            if(this.showResourceType == 3){
                this.$store.dispatch("user/getElectronicTextbooksList",{tePlanCourseId:this.tePlanCourseId}).then((ret) => {
                    if (ret.code == 0){ //开启短信验证
                        this.listInfo = ret.data || [];
                    }
                }).catch((ret) => {

                });
            }else{
                this.$store.dispatch("user/getTeachingPlanCourseResourceList",{tePlanCourseId:this.tePlanCourseId}).then((ret) => {
                    if (ret.code == 0){ //开启短信验证
                        this.listInfo = ret.data || [];
                    }
                }).catch((ret) => {

                });
            }

        },
        submitInfo(){ //关闭
            this.showSMS = false;
        },
        close(){
            this.$emit("closeMsg",false)
        },
        downloadClick(row){
            this.$downLoadFile(row.courseResourceUrl, row.courseResourceName || new Date().getTime());
        },
        onTimeupdate(e){ //判断是否播放完成

        },
        preview(data){ //预览
            this.isFullscreen = false;
            const fileFormat = this.$matchType(data.courseResourceUrl);
            this.show.mp4Show = false;
            this.show.fileShow = false;
            this.show.PDFShow = false;
            this.show.imgShow = false;

            if(fileFormat == 'image'){ //图片
                this.show.imgShow = true;
                this.show.imgUrl = this.$isHttp(data.courseResourceUrl);
                this.show.imgTitle = data.courseResourceName;
            }else if(fileFormat == 'excel' || fileFormat == 'word' || fileFormat == 'ppt'){ //文档
                this.show.fileUrl = "https://forward.cj-edu.com?src=" + this.$isHttp(data.courseResourceUrl);
                this.show.fileShow = true;
            }else if(fileFormat == 'pdf'){ //文档pdf
                this.show.PDFUrl = this.$isHttp(data.courseResourceUrl);
                this.show.PDFShow = true;
            }else if(fileFormat == 'video'){ //视频
                this.showView = true;
                this.show.mp4Show = true;
                this.mp4Url = this.$isHttp(data.courseResourceUrl);
                setTimeout(()=>{
                    this.initVideo();
                },200);
                setTimeout(()=>{
                    let sources = {src:this.$isHttp(data.courseResourceUrl),type:data.courseResourceUrl.indexOf(".mp4")>=0?'video/mp4':data.courseResourceUrl.indexOf(".wmv")>=0?'video/webm':"application/x-mpegURL"}
                    this.player.src(sources);
                    this.player.load(sources);
                    this.player.play(); //播放
                },500);
            }
            this.showView = true;

        },
        initVideo() {
          let this_ = this;
          this.player = this.$video(myVideo, {
              //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
              controls: true,
              //自动播放属性,muted:静音播放
              autoplay: false,
              //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
              preload: "auto",
              autoDisable: true,
              //设置视频播放器的显示宽度（以像素为单位）
              // playbackRates: [0.5, 1, 1.5, 2],
              sources:[ // 视频源
                {
                  src: this.mp4Url,//"../../../static/jl.mp4"
                  poster: ''
                }]
          }, function onPlayerReady() {
            //this_.player.currentTime(5); //指定视频的开始播放位置
          });

        },
        viewClose(){
            if(this.player != null){
                this.player.pause(); //暂停
            }
        }
    }
}
</script>

 <style  lang="less">
  .el-resourceView{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .showBox{
      width: calc(100% - 20px);height: calc(100vh - 220px);border: 1px solid #D3D3D3;
      img{
        width: auto;
      }
    }
    .qpclass{
      position: absolute;right: 59px;width: 40px;height: 40px;bottom: 1px;padding: 2px;
      text-align: center;line-height: 40px;cursor:pointer;
      border-radius: 50%;background-color: #f2f2f2;color: #616161;
    }
    .el-tree-node__children .el-tree-node__content{
      padding-left: 15px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/resourceView.vue